// extracted by mini-css-extract-plugin
export default {"loggedOutToPatients":"LoggedAsTherapist_loggedOutToPatients__8t7jJ","textContainer":"LoggedAsTherapist_textContainer__AkAu5","button":"LoggedAsTherapist_button__JY+Qj"};